//import React, { useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";
import { IFilterMessage, dtoToFilter, filterToQuery, getDefaultFilterMessage } from "../../models/interfaces/IFilterMessage";
//import { ISorter } from "../../models/interfaces/ISorter";
import { ITitle } from "../../models/interfaces/ITitle";
import { ILocation } from "../../models/interfaces/ILocation";
import { useFetchmessagesEANQuery } from "../../redux/slice/api/FO/messageApi";
import { IMessageList } from "../../models/interfaces/IMessage";
import CpntDataTable from "../../components/dataTable/CpntDataTable";
import MessagesFilter from "./components/MessagesNoticesFilter";
import CpntPagination from "../../components/CpntPagination";
import HtmlRenderTypeDemandeNoticeMessage from "../../components/HtmlRender/HtmlRenderTypeDemandeNotice";
import HtmlRenderTypeReponseMessage from "../../components/HtmlRender/HtmlRenderTypeReponseMessage";
import SpinnerEditeurPro from "./components/SpinnerEditeurPro";




const PageMessagesNotices: React.FC = () => {
  const [listfilter, setListFilter] = useState<IFilterMessage>();
  const [searchParams, setSearchParams] = useState<IFilterMessage>();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [isDescending, setIsDescending] = useState<boolean|null>(null);
  const [sortField, setSortField] = useState("");
  const [numberOfResults, setNumberOfResults] = useState<number|null>(null);
  //const [initiateDownload, setInitiateDownload] = useState(false)
  //const [csvDataToDownload, setCsvDataToDownload] = useState(null)
 
  // //const [editeur, setediteur] = useState(""); // État local pour stocker la valeur de l'entrée
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  
  useEffect(() => {
    const storedFilter = localStorage.getItem("IFilterMessagesNotices");
    //const storedSorter = localStorage.getItem("ISortStore");
    console.log(storedFilter);
    if (storedFilter !== null && storedFilter !== undefined) { // && storedSorter !== null && storedSorter !== undefined) {
      const filters = JSON.parse(storedFilter);
      setListFilter(filters);
      setOffset(filters.Offset ?? 0)
      setLimit(filters.Limit ?? 10)
    } else {
      setListFilter(getDefaultFilterMessage());
    }

    // if (storedSorter !== null && storedSorter !== undefined) {
    //   const currSorter:ISorter = JSON.parse(storedSorter);
    //   currSorter?.orderedcolumnid && setSortField(currSorter?.orderedcolumnid);
    //   currSorter?.orderedasc && setIsDescending(!currSorter?.orderedasc);
    // }
   
  }, []);

  useEffect(() => {
    if (listfilter && listfilter !== getDefaultFilterMessage()) {
      const _filter: IFilterMessage = filterToQuery({
        ...listfilter,
        ...(sortField !== "" && { SortField: sortField }),
        ...(isDescending !== null && { IsDescending: isDescending }),
        ...(limit >= 10 && { Limit: limit }),
        ...(offset >= 0 && { Offset: offset }) 
      });
      setSearchParams(_filter);
      localStorage.setItem("IFilterMessagesNotices",JSON.stringify(_filter));
    }
  }, [listfilter, sortField, isDescending, offset, limit]);


  const { data: MessagesEANResult, isFetching: isFetchingMessagesEAN, error:errorMessagesEAN } = useFetchmessagesEANQuery(searchParams, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParams === null || searchParams === undefined || (searchParams.Limit ?? 0) < 10 ,
  });
 
  
  useEffect(() => {
    setNumberOfResults(MessagesEANResult?.Quantite ?? 0);
    localStorage.setItem(
      "NoticesNavigator",
      JSON.stringify(MessagesEANResult?.Messages?.map(n => ({ Ean: n.Ean, idnotice: n.IdNotice, idmessage: n.Id })))
    );
  }, [MessagesEANResult]);


  
  const applyFilter = (data: IFilterMessage) => {
    setListFilter(data);
    setOffset(0);
    setLimit(10);
  }

  const actions: ILocation[] = [
    {
      PathsName: { Voir: "/messagesnotices/noticedetailsmessage/[[Ean]]/[[IdNotice]]/[[Id]]"},
      State: { type_access: "" },
      ClassName: "bi-receipt fs-5 mb-2",
    },
  ];

  const dataHeaderName: ITitle[] = [
    {
      Id: "Id",
      Name: "IdMessage",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) =>
        a.Id - b?.Id,
    },
    
    // {
    //   Id: "Nationalite",
    //   Name: "Nationalite",
    //   Class: "",
    //   sorter: (a: ISociete, b: ISociete) =>
    //     a?.Nationalite?.localeCompare(b?.Nationalite),
    // },
    {
      Id: "IdTypeDemande",
      Name: "Type de demande",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) =>
        0,
    },
    {
      Id: "MarqueLibelle",
      Name: "Libellé de la marque",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) =>
        0,//a?.MarqueLibelle?.localeCompare(b?.MarqueLibelle),
    },
    {
      Id: "EmailDemandeur",
      Name: "E-mail du demandeur",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) =>
        a?.MarqueLibelle?.localeCompare(b?.MarqueLibelle),
    },
    {
      Id: "Ean",
      Name: "Ean",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) =>
        a?.Ean?.localeCompare(b?.Ean),
    },
    {
      Id: "DateDemande",
      Name: "Date d’envoi",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) =>
        a?.DateDemande?.localeCompare(b?.DateDemande),
    },
    {
      Id: "DateReponse",
      Name: "Date de traitement",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) =>
        a?.DateReponse?.localeCompare(b?.DateReponse),
    },
    {
      Id: "IdTypeReponse",
      Name: "Statut du message",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) =>
        (a?.IdTypeReponse ? a?.IdTypeReponse : -1) - (b?.IdTypeReponse ? b?.IdTypeReponse : -1),
    },
  ];


  const dataItemsStyle = {
    Id: "",   
    IdTypeDemande: <HtmlRenderTypeDemandeNoticeMessage />,
    MarqueLibelle:"",
    EmailDemandeur:"",
    Ean:"",
    DateDemande:"",
    DateReponse:"",
    IdTypeReponse: <HtmlRenderTypeReponseMessage />,
  };

  return (
    <>
     <div className="container text-start ">
      <div className="row pt-3 pb-5">
        <div className="col col-12 ">
          <h2 className="titreModule titre-bleu"><i className="bi-chat-left-text pe-2" />Modifications de notices par message</h2>
        </div>
      </div>
      <div className="row card mb-3 mt-2">
          {searchParams && (
            <>
              <MessagesFilter
                filter={dtoToFilter(searchParams)}
                changeFilter={applyFilter}
              />
            {/* Facettes */}
            </>
          )}
           
        </div> 
        <div className="row ">
          {numberOfResults !== null && MessagesEANResult?.Messages && 
            <div className="col-auto pb-3 pt-3">
              Nb de résultats :<b>&nbsp;{numberOfResults}&nbsp;</b>
      
            </div>
          }
          {(isFetchingMessagesEAN) ? (
            <SpinnerEditeurPro />
          ) : (errorMessagesEAN) ? (
            <div>Error</div>
          ) : (
            MessagesEANResult?.Messages && numberOfResults !== null && numberOfResults > 0 &&
              <>
              <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              <div className="card p-0 mb-2">
                <div className="table-responsive">
                  <CpntDataTable
                    data={[
                      ...(MessagesEANResult?.Messages || []),
                  ]}
                    dataHeader={dataHeaderName}
                    dataItemsStyle={dataItemsStyle}
                    actions={actions}
                    actualFilterPage="PageMessagesNotices"
                    updateSorter={setSortField}
                    updateDescending={setIsDescending}
                />
                </div>
              </div>
              <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              </>
          )}
        </div>
      </div>
    </>);
};

export default PageMessagesNotices;


